import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";

// Placeholder for tabs with no content yet.
// `animation` (e.g. "casas" | "barbox" | "empleo") lazy-loads the matching
// Lottie from src/assets/animations/ so the big JSON stays out of the main
// bundle; falls back to a FontAwesome `icon` until (or unless) it loads.
export default function EmptyState({
  icon = "fa-hourglass-half",
  animation,
  title,
  children,
}) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!animation) return;
    let active = true;
    import(`../../../assets/animations/${animation}.json`)
      .then((m) => active && setData(m.default))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [animation]);

  return (
    <div className="empty-state">
      {data ? (
        <Lottie animationData={data} loop className="empty-lottie" />
      ) : (
        <i className={`fa ${icon} empty-icon`} aria-hidden="true"></i>
      )}
      {title && <p style={{ fontWeight: 600 }}>{title}</p>}
      {children && <p>{children}</p>}
    </div>
  );
}
